<template>
  <BlockContainer>
    <ContentArea v-if="!!terms">
      <ContentTitle>{{ terms.title }}</ContentTitle>
      <ContentParagraph class="whitespace-pre-wrap">{{
        terms.terms
      }}</ContentParagraph>
    </ContentArea>
  </BlockContainer>
</template>

<script>
import { get } from "@io/terms";
import { BlockContainer } from "@c/Block";
import { ContentArea, ContentTitle, ContentParagraph } from "@c/Content";

export default {
  name: "Terms",

  meta() {
    return {
      title: this.terms ? this.terms.title.toUpperCase() : ""
    };
  },

  components: {
    BlockContainer,
    ContentArea,
    ContentTitle,
    ContentParagraph
  },

  data: () => ({
    terms: null
  }),

  async created() {
    this.terms = await get();
  }
};
</script>
